import React from 'react';
import { matchPath, Navigate } from 'react-router-dom';

import { useOfferingSidePanelMatch } from '../hooks/useOfferingSidePanelMatch';
import offeringSidePanelBuySideRouteFactory from '../offeringSidePanelBuySideRouteFactory';
import { OfferingSidePanelRouteContext } from '../OfferingSidePanelContainer';
import CommunicatedDemandRoute from './ioi-tracker/CommunicatedDemandRoute';

const OrderAllocationRoute: React.FC = () => {
  const baseSidePanelUrl = React.useContext(OfferingSidePanelRouteContext);
  const sidePanelMatch = useOfferingSidePanelMatch();
  const rest = sidePanelMatch?.rest || '/';

  if (
    matchPath(
      { path: offeringSidePanelBuySideRouteFactory.communicatedDemand.routePath, end: false },
      rest
    )
  ) {
    return <CommunicatedDemandRoute />;
  }

  return (
    <Navigate
      to={baseSidePanelUrl + offeringSidePanelBuySideRouteFactory.communicatedDemand.getUrlPath()}
      replace
    />
  );
};

export default OrderAllocationRoute;
